import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Stack, Typography, Box, IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import dayjs from 'dayjs';
import { DevWinBadge } from '../DevPageBadge';

const TYPE_LABELS = {
  billing_note:    'ใบวางบิล/ใบแจ้งหนี้',
  receipt:         'ใบเสร็จรับเงิน',
  receipt_invoice: 'ใบเสร็จรับเงิน + ใบกำกับภาษี',
  tax_invoice:     'ใบกำกับภาษี',
};

export default function QuickCreateModal({
  open, onClose, targetType, referenceText,
  parentNotes, parentTermsConditions, parentPaymentTerms,
  onConfirm, loading,
}) {
  const [form, setForm] = useState({
    date: '', due_date: '', notes: '', terms_conditions: '', payment_terms: '',
  });

  useEffect(() => {
    if (open) {
      setForm({
        date: dayjs().format('YYYY-MM-DD'),
        due_date: dayjs().format('YYYY-MM-DD'),
        notes: parentNotes || '',
        terms_conditions: parentTermsConditions || '',
        payment_terms: parentPaymentTerms || '',
      });
    }
  }, [open, parentNotes, parentTermsConditions, parentPaymentTerms]);

  const handleSubmit = () => {
    onConfirm({ ...form, reference_text: referenceText || '' });
  };

  return (
    <>
    <DevWinBadge num={144} name="QuickCreateModal" open={open} />
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
        <Typography fontWeight={700}>สร้าง{TYPE_LABELS[targetType]}</Typography>
        <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <Stack spacing={2}>
          {referenceText && (
            <Box sx={{ bgcolor: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 2, p: 1.5 }}>
              <Typography variant="caption" color="text.secondary" fontWeight={600}>เลขที่อ้างอิง (อัตโนมัติ)</Typography>
              <Typography variant="body2" fontWeight={700}>{referenceText}</Typography>
            </Box>
          )}
          <Stack direction="row" spacing={1.5}>
            <TextField
              fullWidth
              label="วันที่ *"
              type="date"
              size="small"
              value={form.date}
              onChange={(e) => setForm((p) => ({ ...p, date: e.target.value }))}
              InputLabelProps={{ shrink: true }}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
            />
            <TextField
              fullWidth
              label="วันครบกำหนด"
              type="date"
              size="small"
              value={form.due_date}
              onChange={(e) => setForm((p) => ({ ...p, due_date: e.target.value }))}
              InputLabelProps={{ shrink: true }}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
            />
          </Stack>
          <TextField
            fullWidth
            label="หมายเหตุ"
            multiline
            rows={2}
            size="small"
            value={form.notes}
            onChange={(e) => setForm((p) => ({ ...p, notes: e.target.value }))}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
          <TextField
            fullWidth
            label="เงื่อนไขการเสนอราคา"
            multiline
            rows={2}
            size="small"
            value={form.terms_conditions}
            onChange={(e) => setForm((p) => ({ ...p, terms_conditions: e.target.value }))}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
          <TextField
            fullWidth
            label="เงื่อนไขการชำระเงิน"
            size="small"
            value={form.payment_terms}
            onChange={(e) => setForm((p) => ({ ...p, payment_terms: e.target.value }))}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
        <Button onClick={onClose} variant="outlined" sx={{ borderRadius: 2 }}>ยกเลิก</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading || !form.date} sx={{ borderRadius: 2 }}>
          {loading ? 'กำลังสร้าง...' : '✅ สร้าง'}
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
}
